// extracted by mini-css-extract-plugin
export default {"main":"Review_main__m5J38","rating":"Review_rating__Jha8d","stars":"Review_stars__demFK"};